/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { LogService, UserService } from '../../../../../core/services';
import { TimerModel } from '../../models';
import { TimerType } from '../../enums';

@Injectable()
export class TimerService {

    /** The pending requests stored in an array */
    private timers: TimerModel[] = [];

    constructor(
        private log: LogService,
        private userService: UserService
    ) {
        this.userService.logOutEmitter
            .subscribe(() => {
                this.flushIntervals();
            });
    }

    /**
     * Add an interval timer
     * @param {string} name
     * @param callback
     * @param {number} seconds
     */
    public addInterval(
        name: string,
        callback,
        seconds: number
    ) {
        if (this.findTimer(name)) {
            return null;
        }
        const timer = <TimerModel>{
            name: name,
            type: TimerType.REPEAT,
            interval: seconds,
            ref: setInterval(callback, seconds * 1000)
        };
        this.log.debug(
            'Timer Service',
            'Created timer called: ' + timer.name
        );
        this.timers.push(timer);
    }

    /**
     * Remove an interval timer
     * @param {string} name
     */
    public removeInterval(
        name: string
    ) {
        const timer = this.findTimer(name);
        if (timer === false) {
            return;
        }
        this.log.debug(
            'Timer Service',
            'Removed timer called: ' + timer.object.name
        );
        clearInterval(timer.object.ref);
        this.timers.splice(timer.index, 1);
    }

    /**
     * Flush all interval timers
     */
    public flushIntervals() {
        this.log.debug(
            'Timer Service',
            'Flush all timers'
        );
        let counter = 0;
        for (const i in this.timers) {
            if (i) {
                clearInterval(this.timers[i].ref);
                this.timers.splice(counter, 1);
                counter++;
            }
        }
        this.timers = [];
    }

    /**
     * Find a timer
     * @param {string} name
     * @returns any
     */
    public findTimer(name: string) {
        let counter = 0;
        for (const i in this.timers) {
            if (i) {
                if (this.timers[i].name === name) {
                    return { object: this.timers[i], index: counter };
                }
                counter++;
            }
        }

        return false;
    }
}
